<template>
  <b-modal
    id="modalError"
    hide-header
    hide-footer
    modal-class="success-submit-modal"
    ignore-enforce-focus-selector=".webim-root"
  >
    <div class="modal__wrapper">
      <div
        class="modal__close"
        @click="() => { hideModal() }"
      >
        <svg
          width="24px"
          height="24px"
        >
          <use xlink:href="#close-modal2" />
        </svg>
      </div>
      <div class="error-message">
        <svg
          class="error-message__icon-top"
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
        >
          <path
            d="M5.03564 17.2477L25.0356 6.24766C25.331 6.08519 25.6626 6 25.9996 6C26.3367 6 26.6683 6.08519 26.9636 6.24766L46.9636 17.2477C47.2772 17.4203 47.5387 17.674 47.7208 17.9821C47.903 18.2903 47.999 18.6417 47.999 18.9997C47.999 19.3576 47.903 19.709 47.7208 20.0172C47.5387 20.3254 47.2772 20.579 46.9636 20.7517L27.9996 31.1817V52.6197L34.0716 49.2797L35.9996 52.7817L26.9636 57.7517C26.6684 57.9145 26.3368 57.9999 25.9996 57.9999C25.6625 57.9999 25.3309 57.9145 25.0356 57.7517L5.03564 46.7517C4.72195 46.5791 4.46034 46.3255 4.27811 46.0173C4.09587 45.7091 3.99971 45.3577 3.99965 44.9997V18.9997C3.99971 18.6416 4.09587 18.2902 4.27811 17.982C4.46034 17.6738 4.72195 17.4202 5.03564 17.2477ZM25.9996 10.2837L10.1496 18.9997L25.9996 27.7157L41.8496 18.9997L25.9996 10.2837ZM7.99965 43.8177L23.9996 52.6177V31.1797L7.99965 22.3797V43.8177Z"
            fill="#ED1651"
          />
          <path
            d="M50.153 39.3359L57.333 32.1559L54.513 29.3359L47.333 36.5159L40.153 29.3359L37.333 32.1559L44.513 39.3359L37.333 46.5159L40.153 49.3359L47.333 42.1559L54.513 49.3359L57.333 46.5159L50.153 39.3359Z"
            fill="#ED1651"
          />
        </svg>
        <div
          class="error-message__text"
          :class="{'error-message__text_list': !messageErrorString}"
        >
          <span
            v-if="messageErrorString"
            v-html="messageErrorString"
          >
          </span>
          <ul v-else>
            <li
              v-for="messageItem in message"
              :key="messageItem.label"
            >
              <strong v-if="messageItem.label">
                {{ messageItem.label }}:
              </strong>
              {{ messageItem.text }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalError',
  props: {
    message: [String, Array],
  },
  computed: {
    isArray() {
      return Array.isArray(this.message);
    },
    messageErrorString() {
      if (this.isArray) {
        if (this.message.length > 1 || !this.message[0].text) return '';
        return `<strong>${this.message[0].label}</strong>: ${this.message[0].text}`;
      }
      return this.message ? this.message : 'В этом населенном пункте доставка невозможна';
    },
  },
  mounted() {
    this.$bvModal.show('modalError');
  },
  methods: {
    hideModal() {
      this.$bvModal.hide('modalError');
      this.$emit('modal_error_close');
    },
  },
};
</script>
<style lang="scss">
  @import './CalculatorModalError.scss';
</style>
